import { ButtonVariantPropTypes } from '~/types/mui';

export const SITE = 'site';
export const HOSTING = 'hosting';
export const SPAMEXPERTS = 'spamexperts';
export const VPS = 'vps';
export const SITELOCK = 'sitelock';
export const PLESK = 'plesk';
export const WINDOWS = 'windows';
export const RESELLER = 'reseller';
export const WEBMAIL = 'webmail';

// SSO button variant types for test ID generation
export const BUTTON_VARIANTS: ButtonVariantPropTypes[] = [
  'outlined',
  'contained',
  'text',
];
